import React, {useMemo, memo} from "react";
//local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {openNewTab} from "helpers/helper";
import {InitialsBadge} from "components/InitialsBadge";
import {subscriptionRelation} from "constants/user.consts";
import cn from "classnames";

const Initials = memo(({isActive, user, members}) => {
  const initialsBadgeUser = useMemo(
    () => (isActive ? user : members?.[0]?.User ?? {}),
    [isActive, user, members]
  );
  return (
    <InitialsBadge
      firstName={initialsBadgeUser.firstName}
      lastName={initialsBadgeUser.lastName}
      needTooltip
      isCurrentUser={isActive}
      counter={members.length - 1}
      addClass={isActive ? "ml-2" : ""}
    />
  );
});

export const SubscriptionStatusRow = ({
  subscription,
  isActive,
  user,
  members,
  disableGetButton,
  onChange,
  t,
}) => {
  const isUserSubscription = useMemo(
    () => subscription.relation === subscriptionRelation.USER,
    [subscription]
  );
  const needInitials = useMemo(
    () => isUserSubscription && !!members?.length,
    [members, isUserSubscription]
  );

  return (
    <div className={cn("subscription__status", {__active: !!isActive})}>
      {needInitials && !isActive && (
        <Initials isActive={isActive} user={user} members={members} />
      )}
      {isActive ? (
        <span className="fz-20 __bold green __uppercase">
          {t("SUBSCRIPTION_TAB_ACTIVE_NOTE")}
        </span>
      ) : subscription.isContactUs ? (
        <ButtonTransparent
          name="SUBSCRIPTION_TAB_CONTACT_BUTTON"
          medium
          onClick={() => openNewTab("https://www.handyday.com/contact")}
        />
      ) : (
        <ButtonTransparent
          name={
            subscription.isFake
              ? "SUBSCRIPTION_TAB_FAKE_BUTTON"
              : "SUBSCRIPTION_TAB_GET_BUTTON"
          }
          medium
          nonTransparent
          disabled={disableGetButton}
          onClick={onChange}
          addClass={needInitials ? "ml-2" : ""}
        />
      )}
      {needInitials && isActive && (
        <Initials isActive={isActive} user={user} members={members} />
      )}
    </div>
  );
};
